import { makeStyles, mergeClasses } from '@fluentui/react-components';
import * as React from 'react';

const useStyles = makeStyles({
    root: {
        width: '20px',
        height: '20px',
        fill: 'currentColor',
    },
});

interface SvgIconProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
    SvgComponent: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const SvgIcon: React.FC<SvgIconProps> = ({ SvgComponent, className, ...props }) => {
    const styles = useStyles();

    return <SvgComponent className={mergeClasses(styles.root, className)} aria-hidden='true' {...props} />;
};
